export enum ReturnType {
  RTS = "RTS",
  REGULAR = "REGULAR",
}

export enum ReturnStatus {
  READY_TO_PROCESS = "READY_TO_PROCESS",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  ARRIVED = "ARRIVED",
  PROCESSING = "PROCESSING",
  REQUESTED = "REQUESTED",
  ON_HOLD = "ON_HOLD",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  TO_BE_RESHIPPED = "TO_BE_RESHIPPED",
}
